var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rsp2GridLayout" }, [
    _c(
      "a",
      {
        class: { rsp2Selected: _vm.layout == "rsp2Grid" },
        on: {
          click: function($event) {
            _vm.setLayout("rsp2Grid")
          }
        }
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14.008",
              height: "14",
              viewBox: "0 0 14.008 14"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Raster",
                d:
                  "M11.508,14a.6.6,0,0,1-.6-.6V11.5a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6v1.9a.6.6,0,0,1-.6.6Zm-5.5,0a.6.6,0,0,1-.6-.6V11.5a.6.6,0,0,1,.6-.6h2a.6.6,0,0,1,.6.6v1.9a.6.6,0,0,1-.6.6Zm-5.4,0a.6.6,0,0,1-.6-.6V11.5a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6v1.9a.6.6,0,0,1-.6.6Zm10.9-5.4a.6.6,0,0,1-.6-.6V6a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6V8a.6.6,0,0,1-.6.6Zm-5.5,0a.6.6,0,0,1-.6-.6h0V6a.6.6,0,0,1,.6-.6h2a.6.6,0,0,1,.6.6h0V8a.6.6,0,0,1-.6.6Zm-5.4,0a.6.6,0,0,1-.6-.6V6a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6h0V8a.6.6,0,0,1-.6.6Zm10.9-5.4a.6.6,0,0,1-.6-.6V.6a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6V2.5a.6.6,0,0,1-.6.6Zm-5.5,0a.6.6,0,0,1-.6-.6h0V.6a.6.6,0,0,1,.6-.6h2a.6.6,0,0,1,.6.6V2.5a.6.6,0,0,1-.6.6Zm-5.4,0a.6.6,0,0,1-.6-.7V.6a.6.6,0,0,1,.6-.6h1.9a.6.6,0,0,1,.6.6V2.5a.6.6,0,0,1-.6.6Z"
              }
            })
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        class: { rsp2Selected: _vm.layout == "rsp2List" },
        on: {
          click: function($event) {
            _vm.setLayout("rsp2List")
          }
        }
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16.333",
              height: "14",
              viewBox: "0 0 16.333 14"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "list",
                d:
                  "M18.633,9.833h-9.1c-.644,0-.7.522-.7,1.167s.056,1.167.7,1.167h9.1c.644,0,.7-.521.7-1.167S19.277,9.833,18.633,9.833Zm0,5.833h-9.1c-.644,0-.7.522-.7,1.167S8.889,18,9.533,18h9.1c.644,0,.7-.521.7-1.167S19.277,15.667,18.633,15.667Zm-9.1-9.333h9.1c.644,0,.7-.522.7-1.167S19.277,4,18.633,4h-9.1c-.644,0-.7.521-.7,1.167S8.889,6.333,9.533,6.333ZM5.8,9.833H3.7c-.644,0-.7.522-.7,1.167s.056,1.167.7,1.167H5.8c.644,0,.7-.521.7-1.167S6.444,9.833,5.8,9.833Zm0,5.833H3.7c-.644,0-.7.522-.7,1.167S3.056,18,3.7,18H5.8c.644,0,.7-.521.7-1.167S6.444,15.667,5.8,15.667ZM5.8,4H3.7C3.056,4,3,4.521,3,5.167s.056,1.167.7,1.167H5.8c.644,0,.7-.522.7-1.167S6.444,4,5.8,4Z",
                transform: "translate(-3 -4)"
              }
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }